import { useEffect } from "react";

// Inietta un blocco JSON-LD nell'head, uno per pagina (id univoco)
export default function JsonLd({ id = "jsonld-page", data }) {
  useEffect(() => {
    if (!data) return undefined;
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = id;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const node = document.getElementById(id);
      if (node) node.remove();
    };
  }, [id, data]);

  return null;
}
